import { Avatar } from "@atoms/index"

import { CompanyAvatarProps } from "./CompanyAvatar.types"

export default function CompanyAvatar(props: CompanyAvatarProps) {
    const { serviceCompany, ...rest } = props

    return <Avatar variant="company" fallbackName={serviceCompany?.name} src={serviceCompany?.logo} {...rest} />
}
